import { render, staticRenderFns } from "./CoursesView.vue?vue&type=template&id=3e74296e&"
import script from "./CoursesView.vue?vue&type=script&lang=js&"
export * from "./CoursesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports